import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { UserState } from '@/types/store/user';

const initialState: UserState = {
  token: null,
  isAuth: false,
  isLoading: false,
  user: null
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setAuthData: (_state, { payload }: PayloadAction<UserState>) => {
      return payload;
    },
    resetAuthData: () => {
      return {
        token: null,
        isAuth: false,
        isLoading: false,
        user: null
      };
    },
    setUser: (state, { payload }: PayloadAction<UserState['user']>) => {
      state.user = payload;
    },
  },
});

export const { setAuthData, resetAuthData, setUser } = userSlice.actions;

export default userSlice.reducer;
